import { render, staticRenderFns } from "./TimeSinceDisplay.vue?vue&type=template&id=065dd10a&"
import script from "./TimeSinceDisplay.vue?vue&type=script&lang=js&"
export * from "./TimeSinceDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports